/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_IssueInputs */

const en_mk_shot_issue = /** @type {(inputs: Mk_Shot_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue detail page: description, staged sub-issues, a properties panel on the right, and the agent’s answer as a comment.`)
};

const id_mk_shot_issue = /** @type {(inputs: Mk_Shot_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman detail issue: deskripsi, sub-issue bertahap, panel properti di kanan, dan komentar hasil kerja agen.`)
};

/**
* | output |
* | --- |
* | "Issue detail page: description, staged sub-issues, a properties panel on the right, and the agent’s answer as a comment." |
*
* @param {Mk_Shot_IssueInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_issue = /** @type {((inputs?: Mk_Shot_IssueInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_IssueInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_issue(inputs)
	return en_mk_shot_issue(inputs)
});